import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { cnpj } from 'cpf-cnpj-validator';
import { UF } from '../../util/uf';
import { Util } from '../../util/util';
import { Filial } from '../filial';
import { FilialService } from '../filial.service';

@Component({
  selector: 'app-filial-maintenance',
  templateUrl: './filial-maintenance.component.html',
  styleUrls: ['./filial-maintenance.component.css']
})
export class FilialMaintenanceComponent implements OnInit {

  id: number;

  isUpdate: string;

  isInfo: boolean = false;

  filial: Filial;

  formularioFilial: FormGroup;

  tituloCrud: string = '';

  public listaUFs: UF[];

  constructor(private filialService: FilialService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef) {

    this.id = history.state.id;
    this.isUpdate = history.state.isUpdate;

    this.filial = new Filial();

    this.formularioFilial = this.formBuilder.group({
      id: 0,
      nome: ['', [Validators.required, Validators.minLength(6)]],
      cnpj: ['', [Validators.required]],
      logradouro: ['', [Validators.required, Validators.minLength(6)]],
      numero: ['', [Validators.required]],
      bairro: ['', [Validators.required, Validators.minLength(5)]],
      cidade: ['', [Validators.required, Validators.minLength(6)]],
      complemento: [''],
      estado: ['', [Validators.required]],
      cep: ['', [Validators.required]],
      fone: ['', [Validators.required]],
      medicoFilial: [],
      especialidadeFilial: [],
      localAtendimento: null
    });

    this.formularioFilial.get('cnpj')?.valueChanges.subscribe(val => {

      if (!cnpj.isValid(this.formularioFilial.controls.cnpj.value)) {

        this.formularioFilial.controls['cnpj'].setErrors({ 'cnpjError': true });
      }

    });

    this.listaUFs = Util.listaUFs;
  }

  ngOnInit() {

    if (this.id) {
      if (this.isUpdate == 'S') {
        this.tituloCrud = 'Alterar Filial';
      } else {
        this.isInfo = true;
        this.tituloCrud = 'Detalhe Filial';
      }
    } else {
      this.tituloCrud = 'Criar Filial';
    }

    this.configurarForm();
  }

  save() {

    this.filial = this.formularioFilial.value;

    if (this.isNew()) {
      this.filialService
        .criar(this.filial).subscribe(data => {
          // console.log(data)

          this.gotoList();
        }, error => {
          console.log(error);
        });
    } else {
      this.filialService.atualizar(this.filial, this.id)
        .subscribe(data => {
          // console.log(data); 

          this.gotoList();
        }, error => {
          console.log(error);
        });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/filiais']);
  }

  isNew(): boolean {
    return this.id == null || this.id == 0;
  }

  get formControl() {
    return this.formularioFilial.controls;
  }

  configurarForm(): void {
    if (!this.isNew()) {
      this.filialService.procurarPorIdSemRelacionamento(this.id)
        .subscribe(data => {
          // console.log(data)

          this.filial = data;
          if (!this.filial.cnpj) {
            this.filial.cnpj = '';
          }

          this.formularioFilial.setValue(this.filial);

          this.formularioFilial.controls.cnpj.patchValue(cnpj.format(this.filial.cnpj));

          this.cd.detectChanges();

          if (this.isUpdate == 'N') {
            this.formularioFilial.disable();
          }
        }, error => {
          console.log(error);
        });
    } else {
      this.formularioFilial.setValue({
        id: 0,
        nome: '',
        cnpj: '',
        logradouro: '',
        numero: '',
        bairro: '',
        cidade: '',
        complemento: '',
        estado: '',
        cep: '',
        fone: '',
        medicoFilial: [],
        especialidadeFilial: [],
        localAtendimento: null
      });
    }
  }
}
